/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_Oauth_FailedInputs */

const cs_settings_meta_oauth_failed = /** @type {(inputs: Settings_Meta_Oauth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta se nepodařilo připojit. Zkuste to znovu.`)
};

const en_settings_meta_oauth_failed = /** @type {(inputs: Settings_Meta_Oauth_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not connect Meta. Try again.`)
};

/**
* | output |
* | --- |
* | "Could not connect Meta. Try again." |
*
* @param {Settings_Meta_Oauth_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_oauth_failed = /** @type {((inputs?: Settings_Meta_Oauth_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_Oauth_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_oauth_failed(inputs)
	return cs_settings_meta_oauth_failed(inputs)
});